// extracted by mini-css-extract-plugin
export default {"innerWrapper":"eu-z","tooltipWrapper":"fu-z","icon":"gu-z","tooltip":"hu-z","content":"iu-z"};